import * as React from 'react';
import React__default from 'react';

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

var _excluded = ["color", "size", "style"];
var Icon = (function (SvgComponent) {
  return /*#__PURE__*/React__default.forwardRef(function (props, ref) {
    var _props$color = props.color,
        color = _props$color === void 0 ? 'currentColor' : _props$color,
        _props$size = props.size,
        size = _props$size === void 0 ? '1em' : _props$size,
        _props$style = props.style,
        style = _props$style === void 0 ? {} : _props$style,
        otherProps = objectWithoutPropertiesLoose(props, _excluded);

    return /*#__PURE__*/React__default.createElement(SvgComponent, _extends_1({
      ref: ref,
      fill: color,
      width: size,
      height: size,
      style: _extends_1({}, style)
    }, otherProps));
  });
});

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M53.1 173.511a11.378 11.378 0 0111.378-11.378h872.289a11.378 11.378 0 0111.377 11.378v282.556a11.378 11.378 0 01-22.755 0V184.889H75.856v587.856h422.866a11.378 11.378 0 110 22.755H64.478A11.378 11.378 0 0153.1 784.122v-610.61z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M787.911 534.756c-102.115 0-184.889 82.784-184.889 184.888 0 102.116 82.774 184.89 184.89 184.89S972.8 821.76 972.8 719.643c0-102.104-82.773-184.888-184.889-184.888zM580.267 719.644C580.267 604.956 673.223 512 787.91 512s207.645 92.956 207.645 207.644S902.599 927.29 787.91 927.29s-207.644-92.957-207.644-207.645z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M766.111 642.844a11.378 11.378 0 0111.378 11.378v75.856h75.844a11.378 11.378 0 010 22.755h-87.222a11.378 11.378 0 01-11.377-11.377v-87.234a11.378 11.378 0 0111.377-11.378zM54.931 167.31a11.378 11.378 0 0115.748-3.333l18.17 11.81a11.378 11.378 0 11-12.402 19.08l-18.17-11.81a11.378 11.378 0 01-3.345-15.747zm891.382 0a11.378 11.378 0 01-3.346 15.747l-18.17 11.81a11.378 11.378 0 01-12.402-19.08l18.17-11.81a11.378 11.378 0 0115.748 3.333zm-836.859 35.442a11.378 11.378 0 0115.736-3.345l36.352 23.632a11.378 11.378 0 01-12.402 19.069l-36.352-23.62a11.378 11.378 0 01-3.334-15.736zm782.336 0a11.378 11.378 0 01-3.333 15.735l-36.352 23.62a11.378 11.378 0 11-12.402-19.068l36.352-23.632a11.378 11.378 0 0115.735 3.345zm-709.632 47.24a11.378 11.378 0 0115.736-3.333l36.352 23.62a11.378 11.378 0 01-12.402 19.08l-36.352-23.62a11.378 11.378 0 01-3.334-15.746zm636.951 0a11.378 11.378 0 01-3.334 15.747l-36.352 23.62a11.378 11.378 0 11-12.401-19.08l36.352-23.62a11.378 11.378 0 0115.735 3.345zm-564.258 47.252a11.378 11.378 0 0115.735-3.333l36.352 23.62a11.378 11.378 0 11-12.401 19.08l-36.375-23.608a11.378 11.378 0 01-3.334-15.747zm491.565 0a11.378 11.378 0 01-3.333 15.747l-36.341 23.62a11.378 11.378 0 11-12.402-19.08l36.34-23.62a11.378 11.378 0 0115.736 3.333zm-418.873 47.252a11.378 11.378 0 0115.736-3.333l36.34 23.62a11.378 11.378 0 11-12.401 19.08l-36.34-23.62a11.378 11.378 0 01-3.335-15.747zm346.192 0a11.378 11.378 0 01-3.345 15.747l-36.34 23.62a11.378 11.378 0 11-12.402-19.08l36.34-23.62a11.378 11.378 0 0115.747 3.333zm-273.499 47.252a11.378 11.378 0 0115.736-3.345l36.34 23.632a11.378 11.378 0 11-12.402 19.08l-36.34-23.631a11.378 11.378 0 01-3.345-15.736zm200.806 0a11.378 11.378 0 01-3.345 15.736l-36.34 23.631a11.378 11.378 0 11-12.402-19.08l36.34-23.632a11.378 11.378 0 0115.747 3.345zM472.93 439a11.378 11.378 0 0115.735-3.345l11.97 7.783 11.969-7.783a11.378 11.378 0 0112.402 19.08l-18.17 11.81a11.378 11.378 0 01-12.402 0l-18.17-11.81A11.378 11.378 0 01472.916 439z"
});

function SvgEmailTime(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "emailTime_svg__icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    ref: svgRef
  }, props), _ref, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailTime);

var ForwardIcon = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(ForwardRef, _extends_1({}, props, {
    ref: ref
  }));
});
var KuFoxIcons = Icon(ForwardIcon);
KuFoxIcons.displayName = 'EmailTimeOutlined';

export default KuFoxIcons;
